export interface CreateExtConfig {
  template: string;
}
